import { render } from "./HowItWorks.vue?vue&type=template&id=ac414896&scoped=true"
const script = {}

import "./HowItWorks.vue?vue&type=style&index=0&id=ac414896&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Desktop\\prueba\\Blooz\\blooz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac414896"]])

export default __exports__